import React from 'react';
import {useState, useEffect} from 'react';
import Changelog from '../../components/Changelog';
import Datarows from '../../components/Datarows';
import {isOfTypeTimeframe, isOfTypeTrader, traderToTimeframes} from '../../core/datatypes/main';
import {useAppDispatch, useAppSelector} from '../../core/hooks';
import {selectLevel, selectUID} from '../../core/reducers/reducer-user';
import {
    mainRequestThunk,
    selectIndicators,
    selectIndicatorsLastUpdated,
    selectStatus,
    selectSymbol,
    selectTimeframe,
    selectTraderType,
    selectView
} from '../../core/reducers/reducer-main';

import {
    selectSubscribedProgress,
    selectSubscribedUserData,
    userSubscribedBiasThunk} from "../../core/reducers/reducer-subscribed-bias";

import {viewTypeIsMultiView, ViewTypes} from '../../core/datatypes/main';

import columns from './columns';
import styles from './content-view.module.css';
import UserSubscribedBias from "../../core/datatypes/UserSubscribedBias";


const ContentView = () => {
    const dispatch = useAppDispatch();
    const status = useAppSelector(selectStatus);
    const timeframe = useAppSelector(selectTimeframe);
    const indicators = useAppSelector(selectIndicators);
    const trader = useAppSelector(selectTraderType);
    const view = useAppSelector(selectView);
    const symbol = useAppSelector(selectSymbol);
    const lastUpdate = useAppSelector(selectIndicatorsLastUpdated);
    const userId = useAppSelector(selectUID);
    const userLevel = useAppSelector(selectLevel);
    const [indicatorArray, setIndicatorArray] = useState<Array<any>>(new Array<any>());
    const [intervalID, setIntervalID] = useState<any>();
    const [subscriptionsID, setSubscriptionsID] = useState<any>();

    const apiSelectSubscribedProgress = useAppSelector(selectSubscribedProgress);
    const apiSelectSubscribedUserData = useAppSelector(selectSubscribedUserData);

    const handleInterval = () => {
        const now = new Date();
        if (now.getUTCDay() >= 1 && now.getUTCDay() <= 5 && now.getUTCHours() >= 10 && now.getUTCHours() <= 22) {
            dispatch(mainRequestThunk("level2"));
        }
    }

    useEffect(() => {
        if ((status === 'idle') && (indicators.length === 0)) {
            dispatch(mainRequestThunk("level2"));
            const thisIID = setInterval(() => {
                handleInterval();
            }, 60000);
            setIntervalID(thisIID);
            const thisSubscriptionID = setInterval(() => {
                handleUserSubscribedBiasThunk();
            }, 20000);
            setSubscriptionsID(thisSubscriptionID);
        }
        if ((status === 'idle') && (indicators.length > 0)) {
            const nextArr = indicators;

            setIndicatorArray(nextArr);
        }
    }, [status, lastUpdate]);

    useEffect(() => {
        return () => {
            clearInterval(intervalID);
            clearInterval(subscriptionsID);
        }
    }, [])

    useEffect(() => {
        // Fetch user data when the component mounts
        handleUserSubscribedBiasThunk()
    }, [userId]);

    const handleUserSubscribedBiasThunk = () => {
        //TODO: improvement work on saving userSubscribedBias in application state
        if (userId !== null) {
            const params = {
                uid: userId
            };
            dispatch(userSubscribedBiasThunk(params));
        }else{
            console.log("User ID is null")
        }
    }

    if ((status === 'loading') && (indicators.length === 0)) {
        return (
            <div className={styles.contentView}>
                Loading...
            </div>
        )
    }


    let datarowArray = new Array<any>();
    if (view === "timeframes-list") {
        datarowArray = indicatorArray.filter(el => timeframe in el).map(el => {
            return {symbol: el.symbol, name: el.name, industry_group: el.industry_group, security_type: el.security_type, ...el[timeframe]}
        });
    } else if (view === "traders-list") {
        datarowArray = indicatorArray.filter(el => traderToTimeframes[trader].every((tf: string) => tf in el)).map(el => {

            //adding bias list to each symbol fro trader-list view
            const subscribedUserArray: typeof UserSubscribedBias[] = apiSelectSubscribedUserData
            const subscribedBiasListSymbol = subscribedUserArray.find(symbol => symbol.symbol === el.symbol && symbol.trader_type === trader);
            let symbolBiasList: number[];
            if (subscribedBiasListSymbol === undefined) {
                symbolBiasList = []
            } else {
                symbolBiasList = subscribedBiasListSymbol.bias_list
            }
            // Order must be maintained. Extra cautious coding present
            const mapObject = Object({symbol: el.symbol, name: el.name, industry_group: el.industry_group, security_type: el.security_type, trade_setup_condition: el[trader], bias_list : symbolBiasList});

            traderToTimeframes[trader].forEach((tf: string) => {
                Object.keys(el[tf]).forEach(k => {
                    if (!(k in mapObject)) {
                        mapObject[k] = {bias: new Array(traderToTimeframes[trader].length)};
                    }
                    const index = traderToTimeframes[trader].indexOf(tf);
                    mapObject[k]['bias'][index] = el[tf][k]['bias'];
                })
            });
            return mapObject
        });

        
    } else if (view === "all") {
        const filterForSymbol = indicatorArray.filter(el => el.symbol === symbol);
        if (filterForSymbol.length === 1) {
            datarowArray = Object.keys(filterForSymbol[0]).filter(k => isOfTypeTimeframe(k)).map(k => {
                return {timeframe: k, ...filterForSymbol[0][k]}
            });
        }
    } else {
        //TODO: add bias list to the data rows here for individual symbols
        const filterForSymbol = indicatorArray.filter(el => el.symbol === symbol);
        if (filterForSymbol.length === 1) {
            const indicatorDict = new Map<string, any>();
            Object.keys(filterForSymbol[0]).filter(k => isOfTypeTimeframe(k)).forEach(k => {
                Object.keys(filterForSymbol[0][k]).forEach(ik => {
                    const ikStr = ik.toString();
                    if (indicatorDict.get(ikStr) === undefined) {
                        indicatorDict.set(ikStr, {indicator: ikStr});
                    }
                    const thisIndicatorEntry = indicatorDict.get(ikStr);
                    thisIndicatorEntry[k] = {...filterForSymbol[0][k][ik]};
                    indicatorDict.set(ikStr, thisIndicatorEntry);
                })
            });
            indicatorDict.forEach(el => datarowArray.push({...el}));
        }
    }

    const columnArray = columns[view];

    let changelogArray = new Array<any>();
    if (view === "timeframes-list") {
        indicatorArray.filter(el => timeframe in el).forEach(el => {
            Object.keys(el[timeframe]).forEach(k => {
                changelogArray.push({...el[timeframe][k]})
            })
        })
    } else if (view === "traders-list") {
        indicatorArray.filter(el => trader in el).forEach(el => {
            changelogArray.push({symbol: el.symbol, ...el[trader]})
        })
    } else {
        const filterForSymbol = indicatorArray.filter(el => el.symbol === symbol);
        if (filterForSymbol.length === 1) {
            Object.keys(filterForSymbol[0]).filter(k => isOfTypeTimeframe(k)).forEach(k => {
                Object.keys(filterForSymbol[0][k]).filter(k => k !== 'symbol').forEach(rk => {
                    changelogArray.push({...filterForSymbol[0][k][rk]})
                })
            });
        }
    }

    let validTradeData = {};
    let datarowArraySorted = datarowArray;
    const indicatorOrder = ["reversal_scout", "slim_ribbon"];
    if ((view !== "timeframes-list") && (view !== "all")) {
        const filterForSymbol = indicatorArray.filter(el => el.symbol === symbol);
        if (filterForSymbol.length === 1) {
            const viewTradeData = filterForSymbol[0][view];
            validTradeData = viewTradeData;
        }
        if (view !== "traders-list") {
            datarowArraySorted = datarowArray.sort((a,b) => indicatorOrder.indexOf(a.indicator) - indicatorOrder.indexOf(b.indicator))
        }
    }

    // const changelogComp = (view !== "traders-list") ? (
    //     <div id="change-log" className={styles.changelogCont}>
    //         <Changelog view={view} data={changelogArray} />
    //     </div>
    // ) : (undefined);

    const dataRowsComp = () => {
        return (
            <div className={styles.datarowsCont}>
                <Datarows data={datarowArraySorted} columns={columnArray} view={view} lastUpdate={lastUpdate} validTradeData={validTradeData}/>
            </div>
        );
    }
    
    const isMultiView = (view === "timeframes-list" || view === "traders-list") || viewTypeIsMultiView(view);

    const linkJumpToChangeLog = isMultiView ? (
        <a href="#change-log" className={styles.mobileOnly}>Jump to change log</a>
    ) : undefined;

    const linkScrollToTop = isMultiView ? (
        <a href="#" onClick={() => window.scrollTo(0, 0)} className={styles.mobileOnly}>Scroll To Top</a>
    ) : undefined;


    return (
        <div className={styles.contentView}>
            { linkJumpToChangeLog }
            {dataRowsComp()}
            { linkScrollToTop }
            <div className={styles.smartGap}></div>
            <div id="change-log" className={styles.changelogCont}>
                <Changelog view={view} data={changelogArray}/>
            </div>
        </div>
    )
}

export default ContentView;